import {Expose} from "class-transformer";

export default class PaymentSystemCountry {
    @Expose({name: 'id'})
    private _id: number | null = null;

    @Expose({name: 'isoA2Code'})
    private _isoA2Code: string | null = null;

    @Expose({name: 'isoA3Code'})
    private _isoA3Code: string | null = null;

    @Expose({name: 'isoNumCode'})
    private _isoNumCode : string | null = null;

    @Expose({name: 'name'})
    private _name: string | null = null;

    @Expose({name: 'fullName'})
    private _fullName: string | null = null;

    @Expose({name: 'continentCode'})
    private _continentCode: string | null = null;

    get id(): number | null {
        return this._id;
    }

    get isoA2Code(): string | null {
        return this._isoA2Code;
    }

    get isoA3Code(): string | null {
        return this._isoA3Code;
    }

    get isoNumCode(): string | null {
        return this._isoNumCode;
    }

    get name(): string | null {
        return this._name;
    }

    get fullName(): string | null {
        return this._fullName;
    }

    get continentCode(): string | null {
        return this._continentCode;
    }
}
